<ng-template #content let-modal>
  <div class="modal-header bg-light p-3">
    <h5 class="modal-title" id="userModalLabel">{{'FILTERS.ADVANCED-TITLE.TEXT' | translate}}</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"
      (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <div class="explore__form-checkbox-list search-home">
      <div class="row">
        <div class="col-lg-4 col-md-6 py-1 pr-30 pl-0 mb-4">
          <!-- Form Property Status -->
          <div class="form-group categories">
            <div class="filter-title d-flex align-items-center justify-content-start mb-2">
              {{'t-district' |
              translate}}
            </div>
            <ng-select (change)="districtChange()" [(ngModel)]="selectedDistrict" [ngModelOptions]="{standalone: true}"
              [placeholder]="'FILTERS.ANY.TEXT' | translate">
              <ng-option *ngFor="let district of searchData.locations"
                [value]="district.countryId + '-' + district.id + '-' + district.regionId">{{district.name}}</ng-option>
            </ng-select>
          </div>
          <!--/ End Form Property Status -->
        </div>
        <div class="col-lg-4 col-md-6 py-1 pr-30 pl-0">
          <!-- Form Property Status -->
          <div class="form-group categories">
            <div class="filter-title d-flex align-items-center justify-content-start mb-2">
              {{'t-county' |
              translate}}
            </div>
            <ng-select (change)="countyChange()" [(ngModel)]="selectedCounty" [ngModelOptions]="{standalone: true}"
              [placeholder]="'FILTERS.ANY.TEXT' | translate">
              <ng-option *ngFor="let c of county" [value]="c.id">{{c.name}}</ng-option>
            </ng-select>
          </div>
          <!--/ End Form Property Status -->
        </div>
        <div class="col-lg-4 col-md-6 py-1 pr-30 pl-0">
          <!-- Form Property Status -->
          <div class="form-group categories">
            <div class="filter-title d-flex align-items-center justify-content-start mb-2">
              {{'t-parish' |
              translate}}
            </div>
            <ng-select [(ngModel)]="selectedParish" [ngModelOptions]="{standalone: true}"
              [placeholder]="'FILTERS.ANY.TEXT' | translate">
              <ng-option *ngFor="let p of parish" [value]="p.id">{{p.name}}</ng-option>
            </ng-select>
          </div>
          <!--/ End Form Property Status -->
        </div>
        <div class="col-lg-3 col-md-3 py-1 pr-30 pl-0">
          <!-- Form Bedrooms -->
          <div class="form-group beds">
            <div class="filter-title d-flex align-items-center text-center mb-2">
              <ion-icon class="me-2" name="bed-outline"></ion-icon>{{'FILTERS.BEDROOMS.TEXT' | translate}}
            </div>
            <div class="d-flex align-items-center">
              <ng-select class="w-100" [(ngModel)]="searchForm.bedrooms" [ngModelOptions]="{standalone: true}"
                [placeholder]="'FILTERS.ANY.TEXT' | translate">
                <ng-option *ngFor="let number of numberSelect" [value]="number">{{number}}</ng-option>
              </ng-select>
            </div>
          </div>
          <!--/ End Form Bedrooms -->
        </div>
        <div class="col-lg-3 col-md-3 py-1 pl-0 pr-30 mb-4">
          <!-- Form Bathrooms -->
          <div class="form-group bath">
            <div class="filter-title d-flex align-items-center mb-2">
              <i class="fa fa-bath me-2" aria-hidden="true"></i>{{'FILTERS.BATHROOMS.TEXT' | translate}}
            </div>
            <div class="d-flex align-items-center">
              <ng-select class="w-100" [(ngModel)]="searchForm.bathrooms" [ngModelOptions]="{standalone: true}"
                [placeholder]="'FILTERS.ANY.TEXT' | translate">
                <ng-option *ngFor="let number of numberSelect" [value]="number">{{number}}</ng-option>
              </ng-select>
            </div>
          </div>
          <!--/ End Form Bathrooms -->
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12 py-1 mb-4 sld">
          <!-- Price Fields -->
          <div class="main-search-field-2">
            <!-- Area Range -->
            <div class="text-center">
              <span class="d-flex mb-2 align-items-center"><ion-icon class="me-2"
                  name="resize-outline"></ion-icon>{{'FILTERS.AREA-RANGE.TEXT' |
                translate}} (m²)</span>
              <div class="d-flex align-items-center mt-1 gap-1">
                <input (change)="inputChange('area')" type="number" class="form-control border-input w-50 area-value"
                  [(ngModel)]="areaValue">
                <span>-</span>
                <input (change)="inputChange('area')" type="number" class="form-control border-input w-50 area-value"
                  [(ngModel)]="areaMaxValue">
              </div>
              <div class="clearfix"></div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12 py-1 mb-4 sld">
          <!-- Price Fields -->
          <div class="main-search-field-2">
            <!-- Price Range -->
            <div class="text-center">
              <span class="d-flex mb-2 align-items-center">
                <ion-icon class="me-2" name="cash-outline"></ion-icon>{{'FILTERS.PRICE-RANGE.TEXT' |
                translate}}
              </span>
              <div class="d-flex align-items-center mt-1 gap-1">
                <input (change)="inputChange('price')" type="number" class="form-control border-input w-50 area-value"
                  [(ngModel)]="priceValue">
                <span>-</span>
                <input (change)="inputChange('price')" type="number" class="form-control border-input w-50 area-value"
                  [(ngModel)]="priceMaxValue">
              </div>
              <div class="clearfix"></div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 py-1 pr-30 pl-0">
          <!-- Form Property Status -->
          <div class="form-group categories">
            <div class="filter-title d-flex align-items-center justify-content-start mb-2">
              <ion-icon class="me-2" name="briefcase-outline"></ion-icon>{{'FILTERS.BUSINESS.TEXT' |
              translate}}
            </div>
            <ng-select [(ngModel)]="searchForm.businessType" [ngModelOptions]="{standalone: true}"
              [placeholder]="'FILTERS.ANY.TEXT' | translate">
              <ng-option *ngFor="let bType of searchData.businessType" [value]="bType.id">{{bType.name}}</ng-option>
            </ng-select>
          </div>
          <!--/ End Form Property Status -->
        </div>
        <div class="col-lg-3 col-md-6 py-1 pr-30 pl-0">
          <!-- Form Property Status -->
          <div class="form-group categories">
            <div class="filter-title d-flex align-items-center justify-content-start mb-2">
              <ion-icon class="me-2" name="business-outline"></ion-icon>{{'FILTERS.PROPERTY-TYPE.TEXT' |
              translate}}
            </div>
            <ng-select [(ngModel)]="searchForm.propertyType" [ngModelOptions]="{standalone: true}"
              [placeholder]="'FILTERS.ANY.TEXT' | translate">
              <ng-option *ngFor="let pType of searchData.propertyType" [value]="pType.id">{{pType.name}}</ng-option>
            </ng-select>
          </div>
          <!--/ End Form Property Status -->
        </div>
        <div class="col-lg-3 col-md-6 py-1 pr-30 pl-0">
          <!-- Form Property Status -->
          <div class="form-group categories">
            <div class="filter-title d-flex align-items-center justify-content-start mb-2">
              <ion-icon class="me-2" name="construct-outline"></ion-icon>{{'FILTERS.PROPERTY-STATE.TEXT' |
              translate}}
            </div>
            <ng-select [(ngModel)]="searchForm.propertyCondition" [ngModelOptions]="{standalone: true}"
              [placeholder]="'FILTERS.ANY.TEXT' | translate">
              <ng-option *ngFor="let sType of searchData.propertyCondition"
                [value]="sType.id">{{sType.name}}</ng-option>
            </ng-select>
          </div>
          <!--/ End Form Property Status -->
        </div>
        <div class="col-lg-3 col-md-3 py-1 pr-30 pl-0">
          <!-- Form Property Status -->
          <div class="form-group categories">
            <div class="filter-title d-flex align-items-center justify-content-start mb-2">
              <ion-icon class="me-2" name="bookmark-outline"></ion-icon>{{'t-reference' |
              translate}}
            </div>
            <input [(ngModel)]="searchForm.reference" [ngModelOptions]="{standalone: true}" type="text"
              class="form-control" placeholder="{{'t-reference' |
                        translate}}">
          </div>
          <!--/ End Form Property Status -->
        </div>
        <div class="col-lg-12 col-md-6 col-sm-12 py-1 mt-3 charac-filters">
          <div class="filter-title d-flex align-items-center text-center mb-2">
            <ion-icon class="me-2" name="build-outline"></ion-icon>{{'FILTERS.CHARACTERISTICS.TEXT' |
            translate}}
          </div>
          <!-- Checkboxes -->
          <div class="checkboxes one-in-row margin-bottom-10 ch-1 row">
            <div *ngFor="let char of searchData.characteristics" class="col-4">
              <input id="check-char-{{char.id}}" type="checkbox" name="check">
              <label for="check-char-{{char.id}}">{{char.name}}</label>
            </div>
          </div>
          <!-- Checkboxes / End -->
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="buttons-modal w-100">
      <button (click)="clearFilters()"
        class="btn float-start w-auto btn-clear d-flex align-items-center">{{'FILTERS.CLEAR.TEXT' | translate}}
        <ion-icon class="fs-5" name="close-outline"></ion-icon></button>
      <button (click)="searchWithAdvanced()"
        class="btn float-end w-auto white d-flex align-items-center btn-search">{{"HOME.SEARCH.TEXT" |
        translate}} <ion-icon class="fs-5 ms-2" name="search-outline"></ion-icon></button>
      <button (click)="searchWithNear()"
        class="btn float-end w-auto white d-flex me-2 align-items-center btn-search">{{"t-search-near" |
        translate}}<ion-icon
          class="fs-5 ms-2" name="locate-outline"></ion-icon></button>
    </div>
  </div>
</ng-template>
